import React from "react";
import { TabsContainer } from "./styledUserTabs";

function UserTabsComponent({ children, ...props }) {
  return (
    <div>
      <TabsContainer
        // defaultActiveKey="personal-purchase"
        // activeKey={1}
        // onSelect={(k) => {
        //   handleTabPush(k);
        // }}
        // id=""
        // className=""
        {...props}
      >
        {children}
      </TabsContainer>
    </div>
  );
}

export default UserTabsComponent;
